import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-lib-fw-animation-wrapper',
  templateUrl: './animation-wrapper.component.html',
  styleUrls: ['./animation-wrapper.component.scss'],
})
export class FormlyAnimationWrapperComponent extends FieldWrapper {

}
